import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { sessionStorageKeys } from '@/constants/sessionStorageKeys';

type FeatureFlagOverrides = Record<string, boolean | string>;

type FeatureFlagOverridesState = {
  overrides: FeatureFlagOverrides;
  setOverride: (key: string, value: boolean | string) => void;
  mergeOverrides: (partial: FeatureFlagOverrides) => void;
  clearOverride: (key: string) => void;
  reset: () => void;
};

const initialState = {
  overrides: {},
} satisfies Pick<FeatureFlagOverridesState, 'overrides'>;

export const useFeatureFlagOverridesStore = create<FeatureFlagOverridesState>()(
  persist(
    (set, get) => ({
      ...initialState,
      setOverride: (key, value) => set({ overrides: { ...get().overrides, [key]: value } }),
      mergeOverrides: partial => set({ overrides: { ...get().overrides, ...partial } }),
      clearOverride: key => {
        const { [key]: _, ...rest } = get().overrides;
        set({ overrides: rest });
      },
      reset: () => set(initialState),
    }),
    {
      name: sessionStorageKeys.DEVTOOLS_FEATURE_FLAG_OVERRIDES,
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);
